import { render, staticRenderFns } from "./EventModalEquipmentLetters.vue?vue&type=template&id=3598fdbc&scoped=true"
import script from "./EventModalEquipmentLetters.vue?vue&type=script&lang=js"
export * from "./EventModalEquipmentLetters.vue?vue&type=script&lang=js"
import style0 from "./EventModalEquipmentLetters.vue?vue&type=style&index=0&id=3598fdbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598fdbc",
  null
  
)

export default component.exports